const comments = [
  {
    avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20portrait%20stylized%20illustration%20warm%20tone%20minimalist%20flat%20design%20simple%20background%20clean%20aesthetic&width=80&height=80&seq=avatar-01&orientation=squarish",
    name: "吃瓜群众小李",
    time: "2小时前",
    content: "这个榜单太真实了！每天都在这里蹲新瓜，mrds的爆料速度真的没话说，比别家快太多了。",
    likes: 328,
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20young%20person%20warm%20colors%20minimalist%20flat%20vector%20portrait%20clean%20simple%20background&width=80&height=80&seq=avatar-02&orientation=squarish",
    name: "八卦研究员",
    time: "5小时前",
    content: "擦边搞笑那块笑死我了，每日大赛新瓜的质量越来越高了，榜单揭晓的排名也很客观。",
    likes: 256,
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=Cute%20stylized%20illustration%20portrait%20warm%20tone%20minimalist%20flat%20design%20young%20vibe%20simple%20clean%20background&width=80&height=80&seq=avatar-03&orientation=squarish",
    name: "深夜追瓜人",
    time: "8小时前",
    content: "每天睡前必刷一遍mrds，不然总觉得错过了什么。黑料和搞笑内容搭配得很好，已经推荐给朋友了。",
    likes: 189,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-10 text-center">
          读者热议
        </h2>
        <div className="space-y-5">
          {comments.map((c, i) => (
            <div key={i} className="bg-background-50 rounded-2xl p-5 md:p-6">
              <div className="flex items-start gap-4">
                <img
                  src={c.avatar}
                  alt={c.name}
                  className="w-10 h-10 md:w-11 md:h-11 rounded-full object-cover flex-shrink-0"
                  onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
                />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-3 mb-1.5 flex-wrap">
                    <span className="font-medium text-sm text-foreground-900 whitespace-nowrap">{c.name}</span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{c.time}</span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{c.content}</p>
                  <div className="mt-3 flex items-center gap-4 text-xs text-foreground-400">
                    <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                      <i className="ri-thumb-up-line w-4 h-4 flex items-center justify-center"></i>
                      {c.likes}
                    </button>
                    <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                      <i className="ri-chat-1-line w-4 h-4 flex items-center justify-center"></i>
                      回复
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}